import { apiRoot } from "./apiRoot";

const campaignCategoryEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["CampaignCategory"],
});

export type CategoryItemPivot = {
  id: number;
  category_id: number;
  category_name?: string;
  category_item_type: string;
  category_item_id: number;
  sort_key: number;
};
export const campaignCategoryApi = campaignCategoryEndpoints.injectEndpoints({
  endpoints: (builder) => {
    return {
      // Create a new category item
      createCategoryItem: builder.mutation<void, CategoryItemPivot[]>({
        query: (category_item_pivots) => ({
          url: `/categoryItems/store`,
          method: "POST",
          body: { category_item_pivots },
        }),
        invalidatesTags: ["CampaignCategory"],
      }),

      updateCategoryItem: builder.mutation<void, CategoryItemPivot[]>({
        query: (category_item_pivots) => ({
          url: `/categoryItems/update`,
          method: "PUT",
          body: { category_item_pivots },
        }),
        invalidatesTags: ["CampaignCategory"],
      }),

      deleteCategoryItem: builder.mutation<void, number>({
        query: (id) => ({
          url: `/categoryItems/${id}/delete`,
          method: "DELETE",
        }),
        invalidatesTags: ["CampaignCategory"],
      }),
    };
  },
});

export const { useCreateCategoryItemMutation, useDeleteCategoryItemMutation, useUpdateCategoryItemMutation } =
  campaignCategoryApi;
